import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { filter, take } from 'rxjs';

import { TransversalEventsService } from '../common/services/transversal-events.service';

import { AddToWishModalComponent } from './add-to-wish-modal/add-to-wish-modal.component';
import { FreeShippingComponent } from './free-shipping/free-shipping.component';
import { ItemProductCartService } from './item-product-cart/item-product-cart.service';
import { ShopCartGiftQueryFacade } from './services/shop-cart-gift-query.facade';
import { ShopCartService } from './services/shop-cart.service';
import { OrderSummaryFeelDiscountComponent } from './shipping-cart/order-summary-feel-discount/order-summary-feel-discount.component';
import { OrderSummaryFuturePriceComponent } from './shipping-cart/order-summary-future-discount/order-summary-future-price.component';
import { ShippingCartComponent } from './shipping-cart/shipping-cart.component';
import { ShopCartComponent } from './shop-cart/shop-cart.component';
import { ShopCartEmptyComponent } from './shop-cart-empty/shop-cart-empty.component';
import { ShopCartErrorsComponent } from './shop-cart-errors/shop-cart-errors.component';
import { ShopCartMaxProductsErrorModalComponent } from './shop-cart-max-products-error-modal/shop-cart-max-products-error-modal.component';
import { ShopcartWishlistModule } from './shopcart-wishlist.module';
import { InitShopCartShared } from './store/shopcart.actions';
import { ShopCartEffects } from './store/shopcart.effects';
import { shopCartReducer } from './store/shopcart.reducer';

import { ApiProductsService } from '@api/_api/api-catalog/api-products/api-products.service';
import { ApiShippingService } from '@api/_api/api-shipping/api-shipping.service';
import { ApiShippingPromotionsService } from '@api/_api/api-shipping-promotions/api-shipping-promotions.service';
import { ProductsService } from '@api/catalog/products/products.service';
import { CountryService } from '@api/country/country.service';
import { ShippingPromotionsService } from '@api/promotions/shipping-promotions.service';
import { ShippingService } from '@api/shipping/shipping.service';
import { MiniPaymentMethodsModule } from '@features/mini-payment-methods/mini-payment-methods.module';
import { TranslatedContentModule } from '@shared/directives/TranslatedContentModule';
import { getActivePath } from '@shared/navigation-button/store/navigation-button.selectors';
import { OrderModule } from '@shared/order/order.module';
import { ProductCommonModule } from '@shared/product/product-common.module';
import { ShippingModule } from '@shared/shipping/shipping.module';
import { SvgIcon2Component } from '@ui/svg-icon/svg-icon.component';

@NgModule({
    declarations: [
        AddToWishModalComponent,
        FreeShippingComponent,
        OrderSummaryFeelDiscountComponent,
        OrderSummaryFuturePriceComponent,
        ShippingCartComponent,
        ShopCartComponent,
        ShopCartEmptyComponent,
        ShopCartErrorsComponent,
        ShopCartMaxProductsErrorModalComponent,
    ],
    imports: [
        StoreModule.forFeature('shopcart', shopCartReducer),
        EffectsModule.forFeature([ShopCartEffects]),
        CommonModule,
        MiniPaymentMethodsModule,
        OrderModule,
        ProductCommonModule,
        ShippingModule,
        ShopcartWishlistModule,
        SvgIcon2Component,
        TranslatedContentModule,
        TranslateModule,
    ],
    exports: [
        AddToWishModalComponent,
        FreeShippingComponent,
        ShippingCartComponent,
        ShopCartComponent,
        ShopCartEmptyComponent,
    ],
    providers: [
        ApiProductsService,
        ApiShippingPromotionsService,
        ApiShippingService,
        CountryService,
        ItemProductCartService,
        ProductsService,
        ShippingPromotionsService,
        ShippingService,
        ShopCartGiftQueryFacade,
        ShopCartService,
        TransversalEventsService,
    ],
})
export class ShopcartModule {
    constructor(private readonly store: Store) {
        this.store.select(getActivePath).pipe(
            filter(path => path !== 'summary' && path !== 'payment'),
            take(1)
        ).subscribe(() => {
            this.store.dispatch(InitShopCartShared());
        });
    }
}
